import type { PlaceOpenState } from '@shared/types';

export function OpenBadge({ state }: { state: PlaceOpenState }) {
  if (!state.isKnown) {
    return <span className="badge badge-neutral">Hours unknown</span>;
  }
  if (state.isOpen) {
    return <span className="badge badge-open">{state.label}</span>;
  }
  return <span className="badge badge-closed">{state.nextChangeLabel ?? 'Closed'}</span>;
}
